export default __webpack_public_path__ + "8c54e7bfa6bc22ab16d434bb146e2bc6.gif";